import React from 'react'
import { Button } from '@deal/components'
import styles from './styles.css'
import { InterstitialProps } from '#src/components/Path/Interstitials'
import { usePathContext } from '#src/components/Path/PathContext'

const GenericWithButton: React.SFC<InterstitialProps> = ({
  submitButtonText,
  interstitialMetadata,
  title,
  body
}) => {
  const pathContext = usePathContext()

  const pageTitle = title
    ? title
    : interstitialMetadata.title
    ? interstitialMetadata.title.text
    : null
  const pageBody = body ? body : interstitialMetadata.body ? interstitialMetadata.body.text : null

  return (
    <div className={styles.page}>
      {pageTitle && <div className={styles.header}>{pageTitle}</div>}
      {pageBody && <div className={styles.body}>{pageBody}</div>}

      <div className={styles.actions}>
        {!pathContext.isBackButtonHidden && pathContext.onPageBack && (
          <div className={styles.back}>
            <Button
              type="button"
              size="large"
              variant="contrast-light"
              tabIndex={2}
              onClick={pathContext.onPageBack}
              disabled={pathContext.isSubmitting}
            >
              Back
            </Button>
          </div>
        )}
        <div className={styles.submit}>
          <Button
            type="submit"
            size="large"
            tabIndex={1}
            disabled={pathContext.isSubmitting}
            onClick={pathContext.onPageSubmitted}
          >
            {pathContext.isSubmitting ? 'Submitting...' : submitButtonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default GenericWithButton
